export enum PartnerCodeStepEnum {
  Init = 0,
  Scan = 10,
  ProfileInfo = 20,
  Reset = 30,
}
